export const SALES_ORDER_ENTITY_VERSION_V2 = 'V2';
export const SALES_ORDER_ENTITY_VERSION_V4 = 'V4';
